const urlDenyCharacters = '% ? \\ / > < { }';

export default urlDenyCharacters;
